module.exports = __webpack_public_path__ + "img/sprite.b3bf8bda.svg";